import React, { useEffect, useMemo } from "react";
import { MergingList } from "./MergingList";
import { MergingListEditForm } from "./MergingListEditForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/mergingListAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";

export const MergingListEditDialog = ({
  match: {
    params: { id },
  },
  history,
  show,
  onHide,
}) => {
  // MergingList UI Context
  // const mergingListUIContext = useMergingListUIContext();
  // const mergingListUIProps = useMemo(() => {
  //   return {
  //     initMergingList: mergingListUIContext.initMergingList,
  //     queryParams: mergingListUIContext.queryParams,
  //     setQueryParams: mergingListUIContext.setQueryParams,
  //   };
  // }, [mergingListUIContext]);

  // MergingList Redux state
  const dispatch = useDispatch();
  const { actionsLoading, mergingListForEdit, error, roleMaster } = useSelector(
    (state) => ({
      actionsLoading: state.mergingList.actionsLoading,
      mergingListForEdit: state.mergingList.mergingListForEdit,
      roleMaster: state.mergingList.roleMaster,
      error: state.mergingList.error,
    }),
    shallowEqual
  );

  if (error) {
    toast.error(error, toastOption);
  }
  useEffect(() => {
    // server call for getting MergingList by id
    dispatch(actions.fetchMergingList(id));
  }, [id, dispatch]);

  const saveMerging = (values) => {
    dispatch(actions.saveMergingList({ ...values, donation_uuid: id })).then(
      (response) => {
        if (response) {
          toast.success(response.message, toastOption);
          history.push("/kurban/list");
        }
      }
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Detail Sisa Merging">
          <CardHeaderToolbar>
            <button
              className="btn btn-secondary"
              onClick={() => history.goBack()}
            >
              Kembali
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <MergingList mergingList={mergingListForEdit} />
        </CardBody>
      </Card>
      <Card>
        <CardHeader title="Ubah Menjadi Kambing" />
        <CardBody>
          <MergingListEditForm saveMerging={saveMerging} />
        </CardBody>
      </Card>
    </>
  );
};
